<script lang="ts">
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import TemplateStandard from '../../../shared/TemplateStandard.svelte';
    import { mainMenu, planning, readonlyMode } from '../../../../stores/store';
    import ScenarioList from './ScenarioList.svelte';
    import ScenarioRoutingProgressBar from './ScenarioRoutingProgressBar.svelte';
    import MonitActionForSelectedAssignments from './MonitActionForSelectedAssignments.svelte';
    import SwitchQuickCategoryHideMethod from '../QuickCategories/SwitchQuickCategoryHideMethod.svelte';
    import TemplateHeaderTrio from '../../../shared/TemplateHeaderTrio.svelte';
    import SwitchPlanningAdHocMode from './SwitchPlanningAdHocMode.svelte';

    let showMonit: boolean = true;

    onMount(() => {
        $planning.assignments = 0;
    });

    $planning.forceToSetTacticalPlan = $mainMenu.currentPage !== 'PagePlanning';
    $mainMenu.currentPage = 'PagePlanning';
    $planning.planningStarted = false;

    $: showMonit = $planning.selectedAssignments.length > 0;
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderTrio>
            <div slot="main-header">
                <div style="display: flex; align-items: center; column-gap: 10px;">
                    <div>{$_('Planning')}</div>
                </div>
            </div>
            <div slot="main-search">
                <!--                <ScenarioRoutingProgressBar progress={$planning.routingProgress} />-->
            </div>
            <div slot="main-buttons">
                {#if $planning.currentScenarioId !== null && $planning.assignments > 0}
                    <div
                        style="font-size: 14px; font-weight: 400; display: flex; flex-direction: row;"
                    >
                        <SwitchQuickCategoryHideMethod />
                        <SwitchPlanningAdHocMode />
                    </div>
                {/if}
            </div>
        </TemplateHeaderTrio>
    </div>
    <div slot="content" style="display: flex; flex-direction: column; overflow-y: auto;">
        <ScenarioList bind:day={$planning.selectedDay} onlyLocked={false} />
    </div>
    <div slot="monit">
        {#if showMonit}
            <div style="position: relative; z-index: 200;">
                <MonitActionForSelectedAssignments bind:showMonit readonlyMode={$readonlyMode} />
            </div>
        {/if}
    </div>
</TemplateStandard>

<style>
</style>
